import { render, staticRenderFns } from "./ExhibitionDetail.vue?vue&type=template&id=61647b96&"
import script from "./ExhibitionDetail.vue?vue&type=script&lang=js&"
export * from "./ExhibitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports